import CryptoJs from "crypto-js";
import { getEncryptionKeyIfSet } from "../util/config";
import { safeParse } from "../util/json";

const U_INFO_KEY = "u_info";
const U_ID_KEY = "u_id";
const PROFILE_ID_KEY = "profile_id";

type SessionUser = {
  id?: string | number | null;
  [key: string]: unknown;
};

export type AuthSession = {
  access_token: string;
  refresh_token?: string;
  user?: SessionUser;
  [key: string]: unknown;
};

export function loadSession(): AuthSession | null {
  const key = getEncryptionKeyIfSet();
  if (!key) return null;

  try {
    const raw = localStorage.getItem(U_INFO_KEY);
    if (!raw) return null;

    const decrypted = CryptoJs.AES.decrypt(raw, key).toString(CryptoJs.enc.Utf8);
    if (!decrypted) return null;

    const parsed = safeParse(decrypted) as AuthSession | null;
    if (!parsed || !parsed.access_token) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSession(session: AuthSession): void {
  const key = getEncryptionKeyIfSet();
  if (!key || !session) return;

  try {
    const encrypted = CryptoJs.AES.encrypt(JSON.stringify(session), key).toString();
    localStorage.setItem(U_INFO_KEY, encrypted);

    if (session.user && session.user.id != null) {
      localStorage.setItem(U_ID_KEY, String(session.user.id));
    }
  } catch (error) {
    console.warn("Auth storage save failed", error);
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(U_INFO_KEY);
    localStorage.removeItem(U_ID_KEY);
    localStorage.removeItem(PROFILE_ID_KEY);
  } catch (error) {
    console.warn("Auth storage clear failed", error);
  }
}

export function saveProfileId(profileId: string | number | null | undefined): void {
  try {
    if (profileId == null || String(profileId).trim() === "") {
      localStorage.removeItem(PROFILE_ID_KEY);
      return;
    }
    localStorage.setItem(PROFILE_ID_KEY, String(profileId));
  } catch (error) {
    console.warn("Profile id save failed", error);
  }
}

export function loadProfileId(): string | null {
  try {
    const profileId = localStorage.getItem(PROFILE_ID_KEY);
    if (!profileId || String(profileId).trim() === "") return null;
    return String(profileId);
  } catch {
    return null;
  }
}
